import { useEffect, useRef, useState } from 'react';
import type { Song } from '../data/mockCatalog';

export function useAutoPreview(song: Song | null | undefined, enabled: boolean) {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio || !enabled || !song) return undefined;
    audio.currentTime = 0;
    audio.volume = 0.34;
    audio.onended = () => setPlaying(false);
    let previewTimer: number;
    audio.play().then(() => {
      setPlaying(true);
      previewTimer = window.setTimeout(() => {
        audio.pause();
        audio.currentTime = 0;
        setPlaying(false);
      }, 20000);
    }).catch(() => setPlaying(false));
    return () => {
      window.clearTimeout(previewTimer);
      audio.pause();
      audio.currentTime = 0;
      audio.onended = null;
      setPlaying(false);
    };
  }, [song, enabled]);

  return { audioRef, playing };
}
